export var FFMS;
(function (FFMS) {
    let OrderStatus;
    (function (OrderStatus) {
        OrderStatus["Waiting"] = "Waiting";
        OrderStatus["Following"] = "Following";
        OrderStatus["Complete"] = "Complete";
    })(OrderStatus = FFMS.OrderStatus || (FFMS.OrderStatus = {}));
})(FFMS || (FFMS = {}));
export var FFMSLevelAdmin;
(function (FFMSLevelAdmin) {
    let CUSTOMER_TYPE;
    (function (CUSTOMER_TYPE) {
        CUSTOMER_TYPE["TERMINAL_CLIENT"] = "TERMINAL_CLIENT";
        CUSTOMER_TYPE["CO_LOADER"] = "CO_LOADER";
        CUSTOMER_TYPE["POTENTIAL_CLIENT"] = "POTENTIAL_CLIENT";
    })(CUSTOMER_TYPE = FFMSLevelAdmin.CUSTOMER_TYPE || (FFMSLevelAdmin.CUSTOMER_TYPE = {}));
})(FFMSLevelAdmin || (FFMSLevelAdmin = {}));
export var FFMSOverView;
(function (FFMSOverView) {
    let FreightTag;
    (function (FreightTag) {
        FreightTag["FASTEST"] = "FASTEST";
        FreightTag["EARLIEST"] = "EARLIEST";
        FreightTag["CHEAPEST"] = "CHEAPEST";
        FreightTag["AVAILABLE_BOOKING"] = "AVAILABLE_BOOKING";
    })(FreightTag = FFMSOverView.FreightTag || (FFMSOverView.FreightTag = {}));
})(FFMSOverView || (FFMSOverView = {}));
export var FFMSOrder;
(function (FFMSOrder) {
    let ORDER_TYPE;
    (function (ORDER_TYPE) {
        ORDER_TYPE["NOT_FOLLOWED"] = "NOT_FOLLOWED";
        ORDER_TYPE["FOLLOWING"] = "FOLLOWING";
        ORDER_TYPE["COMPLETED"] = "COMPLETED";
    })(ORDER_TYPE = FFMSOrder.ORDER_TYPE || (FFMSOrder.ORDER_TYPE = {}));
    let NEXT_ORDER_TYPE;
    (function (NEXT_ORDER_TYPE) {
        NEXT_ORDER_TYPE["NOT_FOLLOWED"] = "FOLLOWING";
        NEXT_ORDER_TYPE["FOLLOWING"] = "COMPLETED";
        NEXT_ORDER_TYPE["COMPLETED"] = "";
    })(NEXT_ORDER_TYPE = FFMSOrder.NEXT_ORDER_TYPE || (FFMSOrder.NEXT_ORDER_TYPE = {}));
})(FFMSOrder || (FFMSOrder = {}));
export var FFMSStatic;
(function (FFMSStatic) {
    let StaticType;
    (function (StaticType) {
        StaticType["PLATFORM"] = "PLATFORM";
        StaticType["MINE"] = "MINE";
    })(StaticType = FFMSStatic.StaticType || (FFMSStatic.StaticType = {}));
    let CustomerType;
    (function (CustomerType) {
        CustomerType["TERMINAL_CLIENT"] = "TERMINAL_CLIENT";
        CustomerType["CO_LOADER"] = "CO_LOADER";
        CustomerType["POTENTIAL_CLIENT"] = "POTENTIAL_CLIENT";
    })(CustomerType = FFMSStatic.CustomerType || (FFMSStatic.CustomerType = {}));
    let OperateType;
    (function (OperateType) {
        OperateType["SEARCH"] = "SEARCH";
        OperateType["BOOKING"] = "BOOKING";
        OperateType["COLLECT"] = "COLLECT";
        OperateType["DETAIL"] = "DETAIL";
    })(OperateType = FFMSStatic.OperateType || (FFMSStatic.OperateType = {}));
})(FFMSStatic || (FFMSStatic = {}));
